<app-header></app-header>
<div class="title"></div>
<div class="margin-top-70">
  <div class="container">
    <div class="row">
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Status
              </td>
              <td>
                <app-drop-down-single-select
                  [DropDownOptions]="listStatus"
                  (typeSelectedChanged)="updateSelectedType($event)"
                  [name]="'status'"
                ></app-drop-down-single-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="mx-auto col-md-6 mt-6">
        <table class="table table-bordered">
          <tbody>
            <tr>
              <td class="v-align-m">
                Date Modified
              </td>
              <td>
                <app-drop-down-single-select
                  [name]="'dateModified'"
                  [DropDownOptions]="listDateModified"
                  (typeSelectedChanged)="updateSelectedType($event)"
                ></app-drop-down-single-select>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<div class="container table-responsive">
  <div class="d-grid gap-2 d-md-flex justify-content-md-end">
    <button
      [disabled]="showSearchLoading"
      type="submit"
      class="btn btn-primary btn-pkt"
      (click)="searchProduct()"
    >
      {{searchBtnText}}
      <i class="bi bi-search ps-1" *ngIf="!showSearchLoading"></i>
      <span
        *ngIf="showSearchLoading"
        class="spinner-border spinner-border-sm"
        role="status"
        aria-hidden="true"
      ></span>
    </button>
    <button
      class="btn btn-primary btn-pkt"
      type="button"
      (click)="downloadReport()"
    >
      <i class="fa fa-download"></i> Download
    </button>
    <button class="btn btn-primary btn-pkt" (click)="clearFilters()">
      Reset<i class="bi bi-trash ps-1"></i>
    </button>
  </div>
</div>

<div class="container">
  <div class="" style="overflow-x: scroll;">
    <table
      class="table table-hover table-bordered table-striped mt-2 pkt-table-style"
    >
      <thead class="thead-dark">
        <tr>
          <th scope="col">Netsuite ID</th>
          <th scope="col">Date Modified</th>
          <th scope="col">Product ID</th>
          <th scope="col">Title</th>
          <th scope="col">Contract Name</th>
          <th scope="col">Author Name</th>
          <th scope="col">Currency</th>
          <th scope="col">Amount</th>
          <th scope="col">No. of Chapters</th>
          <th scope="col">Discription</th>
          <th scope="col">Stage</th>
          <th scope="col">Status</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of products; let i = index;">
          <td>{{product.netsuite_internal_id}}</td>
          <td>{{product.formatted_date}}</td>
          <td>{{product.part_number}}</td>
          <td>{{product.title}}</td>
          <td>{{product.contract_name}}</td>
          <td>{{product.author_name}}</td>
          <td>{{getCurrency(product.current_currency_smb)}}</td>
          <td>{{product.advance_amount | number: '1.2-2'}}</td>
          <td>{{product.no_of_chapter}}</td>
          <td>{{product.description}}</td>
          <td>{{product.amount_condition}}</td>
          <td>{{product.advance_status}}</td>
        </tr>
      </tbody>
    </table>
    <!-- Total Products {{totalProducts}} -->
  </div>
</div>
<div class="container">
  <app-pagination
    [maxSize]="maxSize"
    [pageSize]="pageSize"
    [collectionSize]="totalProducts"
    (pageChanged)="updatePageData($event)"
  ></app-pagination>
</div>

<app-footer></app-footer>
